import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../../../hook/useAuth";
import { getAccessControl, put_AccessControl } from "../../../services/AccessControl";
import { isTokenExpired } from "../../../utils/isTokenExpired";

type Props = {
    roleId: number;
    searchValue: string;
    getExpandGroupsDetails: (expandList: any[]) => void;
    setPleaseWait: (wait: boolean) => void;
    isChange: number;
    updateToZeroChange: () => void;
};

export default function AllRoles({
    roleId,
    searchValue,
    getExpandGroupsDetails,
    setPleaseWait,
    isChange,
    updateToZeroChange
}: Props) {
    const token = Cookies.get("token-express-tire");
    const expires = Cookies.get("expires-express-tire");
    const navigate = useNavigate();
    const { setAuth }: any = useAuth();
    const [roles, setRoles] = useState<any[]>([]);
    const [filterRoles, setFilterRoles] = useState<any[]>([]);
    const [isChangeAll, setIsChangeAll] = useState<boolean>(false);

    useEffect(() => {
        setPleaseWait(true);
        getAccessControl("accessControls", { roleId }, token!.toString())
            .then((response) => {
                const grouped = response.reduce(
                    (result: any[], item: any) => {
                        if (!result[item.groupName]) {
                            result[item.groupName] = [];
                        }
                        result[item.groupName].push(item);
                        return result;
                    },
                    {}
                );

                setRoles(() =>
                    Object.keys(grouped).map((key) => {
                        return {
                            groupName: key,
                            isExpand: false,
                            sections: grouped[key],
                        };
                    })
                );

                setFilterRoles(() =>
                    Object.keys(grouped).map((key) => {
                        return {
                            groupName: key,
                            isExpand: false,
                            sections: grouped[key],
                        };
                    })
                );
                setPleaseWait(false);
            })
            .catch(() => {
                setPleaseWait(false);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [roleId]);

    useEffect(() => {
        if (isChange !== 0) {
            setFilterRoles(() =>
                filterRoles.map((item: any) => {
                    if (item.isExpand) {
                        return {
                            ...item,
                            sections: item.sections.map((data: any) => {
                                return {
                                    ...data,
                                    allowDenyStatusId: isChange,
                                };
                            }),
                        };
                    }
                    return item;
                })
            );

            setRoles(() =>
                roles.map((item: any) => {
                    if (filterRoles.find((filterData: any) => filterData.groupName === item.groupName) ? filterRoles.find((filterData: any) => filterData.groupName === item.groupName).isExpand : item.isExpand) {
                        return {
                            ...item,
                            sections: item.sections.map((data: any) => {
                                return {
                                    ...data,
                                    allowDenyStatusId: isChange,
                                };
                            }),
                        };
                    }
                    return item;
                })
            );

            setIsChangeAll(true);
            setPleaseWait(false);
            updateToZeroChange();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isChange]);

    useEffect(() => {
        if (!isChangeAll) {
            if (roles)
                setFilterRoles(() =>
                    roles
                        ?.filter(
                            (item: any) =>
                                item.groupName
                                    .toLowerCase()
                                    .includes(searchValue?.toLowerCase()) ||
                                item.sections?.find(
                                    (value: any) =>
                                        value.section &&
                                        value.section
                                            .toLowerCase()
                                            .includes(searchValue?.toLowerCase())
                                ) ||
                                item.sections?.find(
                                    (value: any) =>
                                        value.action &&
                                        value.action
                                            .toLowerCase()
                                            .includes(searchValue.toLowerCase())
                                )
                        )
                        ?.map((data: any) => {
                            return {
                                ...data,
                                isExpand: filterRoles.find(
                                    (filterData: any) => filterData.groupName === data.groupName
                                )?.isExpand,
                                sections: data.sections?.filter(
                                    (filterData: any) =>
                                        (filterData.section &&
                                            filterData.section
                                                .toLowerCase()
                                                .includes(searchValue.toLowerCase())) ||
                                        (filterData.action &&
                                            filterData.action
                                                .toLowerCase()
                                                .includes(searchValue.toLowerCase()))
                                ),
                            };
                        })
                );
        } else {
            setIsChangeAll(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue, roles]);

    useEffect(() => {
        getExpandGroupsDetails(filterRoles.filter((item: any) => item.isExpand));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterRoles]);

    const updatedSingleSelection = async (
        id: number,
        allowDenyStatusId: number
    ) => {
        if (isTokenExpired(expires)) {
            setAuth(null);

            Cookies.remove("tenantId-express-tire");
            Cookies.remove("token-express-tire");
            Cookies.remove("roleId-express-tire");
            Cookies.remove("role-express-tire");
            Cookies.remove("userId-express-tire");
            Cookies.remove("isAdmin-express-tire");
            Cookies.remove("profileImg-express-tire");
            Cookies.remove("expires-express-tire");
            navigate("/login")
        }

        setPleaseWait(true);
        put_AccessControl(id, allowDenyStatusId, token!.toString())
            .then(() => {
                setFilterRoles(() =>
                    filterRoles.map((item: any) => {
                        if (item.sections.find((value: any) => value.id === id)) {
                            return {
                                ...item,
                                sections: item.sections.map((data: any) => {
                                    if (data.id === id) {
                                        return {
                                            ...data,
                                            allowDenyStatusId: allowDenyStatusId,
                                        };
                                    }
                                    return data;
                                }),
                            };
                        }
                        return item;
                    })
                );

                setRoles(() =>
                    roles.map((item: any) => {
                        if (item.sections.find((value: any) => value.id === id)) {
                            return {
                                ...item,
                                sections: item.sections.map((data: any) => {
                                    if (data.id === id) {
                                        return {
                                            ...data,
                                            allowDenyStatusId: allowDenyStatusId,
                                        };
                                    }
                                    return data;
                                }),
                            };
                        }
                        return item;
                    })
                );

                setPleaseWait(false);
            })
            .catch(() => {
                setPleaseWait(false);
            });
    };

    return (
        <div className="p-6">
            {
                filterRoles?.map((header: any, index: number) => {
                    return (
                        <div
                            key={index}
                            className={`border rounded-md mb-2 cursor-pointer border-secondary`}
                        >
                            <div
                                className={`flex flex-row justify-between items-center p-1.5
                ${header.isExpand ? 'rounded-t-md' : 'rounded-md'}
                bg-white
                text-secondary      
              `}
                                onClick={() =>
                                    setFilterRoles((prevRoles) => {
                                        const result = [...prevRoles];
                                        result[index] = {
                                            ...result[index],
                                            isExpand: !header.isExpand,
                                        };
                                        return result;
                                    })
                                }
                            >
                                <p className="m-0 text-sm select-none">{header.groupName}</p>
                                {header.isExpand ? (
                                    <svg
                                        width="20"
                                        height="20"
                                        fill="red"
                                        viewBox="0 0 24 24"
                                    >
                                        <path d="M7.41 8.59L12 13.17L16.59 8.59L18 10L12 16L6 10L7.41 8.59Z" />
                                    </svg>
                                ) : (
                                    <svg
                                        width="20"
                                        height="20"
                                        fill="blue"
                                        viewBox="0 0 24 24"
                                    >
                                        <path d="M9.29 6.71L13.58 11L9.29 15.29L10.71 16.71L16.41 11L10.71 5.29L9.29 6.71Z" />
                                    </svg>
                                )}
                            </div>

                            {/* ExpandList */}
                            <div className={`${header.isExpand ? 'block' : 'hidden'} cursor-default`}>
                                <hr className="bg-[#737373]" />
                                <div className="flex flex-row items-center px-2 py-[0.625rem]">
                                    <h5 className={`w-1/3 font-normal m-0 text-secondary`}>Section</h5>
                                    <h5 className={`w-1/3 font-normal m-0 text-secondary`}>Action</h5>
                                    <div className="w-1/3 flex flex-row justify-end items-center opacity-20">
                                        <button className="cursor-default bg-gray-500 text-white rounded-l-sm capitalize text-[10px] font-bold h-5 border-none px-[10px]">
                                            Not Set
                                        </button>
                                        <button className="cursor-default bg-green-400 text-white capitalize text-[10px] font-bold h-5 border-none px-[10px]">
                                            Allow
                                        </button>
                                        <button className="cursor-default bg-red-600 text-white rounded-r-sm capitalize text-[10px] font-bold h-5 border-none px-[10px]">
                                            Deny
                                        </button>
                                    </div>
                                </div>
                                <hr className="my-0" />

                                {
                                    header?.sections?.map((item: any, index: number, arr: any[]) => {
                                        return (
                                            <React.Fragment key={index}>
                                                <div className="flex flex-row items-center px-2 py-2">
                                                    <h5 className={`w-1/3 font-normal text-[10px] m-0 text-secondary`}>
                                                        {item.section}
                                                    </h5>
                                                    <h5 className={`w-1/3 font-normal text-[10px] m-0 text-secondary`}>
                                                        {item.action}
                                                    </h5>
                                                    <div className="w-1/3 flex flex-row justify-end items-center">
                                                        <button
                                                            className={`${item.allowDenyStatusId === 1
                                                                ? 'opacity-100 cursor-default'
                                                                : 'opacity-20 cursor-pointer'
                                                                } bg-gray-500 text-white rounded-l-sm capitalize text-[10px] font-bold h-5 border-none px-[10px]`}
                                                            onClick={() => {
                                                                if (item.allowDenyStatusId !== 1) {
                                                                    updatedSingleSelection(item.id, 1);
                                                                }
                                                            }}
                                                        >
                                                            Not Set
                                                        </button>

                                                        <button
                                                            className={`${item.allowDenyStatusId === 2
                                                                ? 'opacity-100 cursor-default'
                                                                : 'opacity-20 cursor-pointer'
                                                                } bg-green-400 text-white capitalize text-[10px] font-bold h-5 border-none px-[10px]`}
                                                            onClick={() => {
                                                                if (item.allowDenyStatusId !== 2) {
                                                                    updatedSingleSelection(item.id, 2);
                                                                }
                                                            }}
                                                        >
                                                            Allow
                                                        </button>

                                                        <button
                                                            className={`${item.allowDenyStatusId === 3
                                                                ? 'opacity-100 cursor-default'
                                                                : 'opacity-20 cursor-pointer'
                                                                } bg-red-600 text-white rounded-r-sm capitalize text-[10px] font-bold h-5 border-none px-[10px]`}
                                                            onClick={() => {
                                                                if (item.allowDenyStatusId !== 3) {
                                                                    updatedSingleSelection(item.id, 3);
                                                                }
                                                            }}
                                                        >
                                                            Deny
                                                        </button>
                                                    </div>
                                                </div>
                                                {arr.length - 1 !== index && (
                                                    <hr className="bg-[#404954]" />
                                                )}
                                            </React.Fragment>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    );
                })
            }
        </div>
    );
}
